import Footer from "../components/common/footer";
import { Helmet } from "react-helmet";
import HeaderTwo from "../components/common/headerTwo";
import Hero from "../components/contact/hero";
import Faq from "../components/home/faq";
import MapGoogle from "../components/common/map";
import ContactTimeline from "../components/contact/contactTimeline";
function Contact() {
  return (
    <>
      <Helmet>
        <title>Kontakt | Drzewus</title>
        <meta name="title" content="Kontakt | Drzewus" />
        <meta
          name="description"
          content="Świadczymy kompleksowe usługi ogrodnicze, w tym projektowanie ogrodów, pielęgnację zieleni, wycinkę drzew i krzewów oraz nawadnianie."
          key="desc"
        />
        <meta property="og:title" content="Kontakt | Drzewus" />
        <meta
          property="og:description"
          content="Świadczymy kompleksowe usługi ogrodnicze, w tym projektowanie ogrodów, pielęgnację zieleni, wycinkę drzew i krzewów oraz nawadnianie."
        />
        <meta
          property="og:image"
          content="https://yourdomain.com/path/to/og-image.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Hero />
        <ContactTimeline/>
        <Faq />
       <MapGoogle />


      </main>
      <Footer />
    </>
  );
}
export default Contact;
